(function(){
  'use strict';
  if (window.DSDGMOR && window.DSDGMOR.version) return;

  var VERSION = 'p11dz600-gmor-playback-reconstruction-20261011-r5';
  var SOURCE = 'DSD_THEME_v26_P7r_ios_safe_area_modal_fix.zip';
  var videos = new Map();
  var registered = new WeakSet();
  var observer = null;
  var mutationObserver = null;
  var activeVideo = null;
  var activeOwner = '';
  var externalAudio = null;
  var mediaUnlocked = false;
  var modalOwner = '';
  var modalClaims = {};
  var modalClaimOrder = [];
  var booted = false;
  var pendingAutoplayFrame = null;
  var pendingScanTimer = null;
  var pendingScanRoots = [];
  var pendingViewportTimer = null;
  var pendingPrewarmTimer = null;
  var prewarmVideo = null;
  var playbackRecoveryByVideo = new WeakMap();
  var lastAutoplayAttempt = new WeakMap();
  var muteWriteSuppressedUntil = new WeakMap();
  var userGestureState = new WeakMap();
  var manualPauseState = new WeakMap();
  var programmaticPauseUntil = new WeakMap();
  var modalResumeCandidate = null;
  var modalResumeWasPlaying = false;
  var VIDEO_MUTED_KEY = 'dsd.video.muted.v1';
  var AUTOPLAY_COOLDOWN_MS = 350;
  var SCAN_DEBOUNCE_MS = 80;
  var VIEWPORT_DEBOUNCE_MS = 120;
  var playbackDiagnostics = {
    attempts: 0,
    recoveries: 0,
    rejections: 0,
    lastError: '',
    lastStartupMs: 0,
    scans: 0,
    scannedVideos: 0,
    prewarmChanges: 0
  };

  function qsa(selector, root){
    try { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
    catch(e){ return []; }
  }

  function claimRuntime(){
    window.DSDRuntimeRegistry = window.DSDRuntimeRegistry || {};
    window.DSDRuntimeRegistry.gmor = {
      version: VERSION,
      owner: 'GlobalMediaOwnershipRuntime',
      recoveredFrom: SOURCE,
      canonical: true,
      owns: ['feed-video', 'story-video', 'modal-video', 'wasabi-video', 'viewport-media', 'audio-unlock']
    };
    if (window.DSDRegistry && typeof window.DSDRegistry.claim === 'function') {
      try { window.DSDRegistry.claim('gmor', window.DSDRuntimeRegistry.gmor); } catch(e){}
    }
    window.initializeVideoEvents = function(){ return false; };
    window.initVideoTracking = function(){ return false; };
    writeDomState();
  }

  function surfaceFor(video, meta){
    if (meta && meta.surface) return meta.surface;
    if (video.closest('.dsd-msg384__message-media, [data-dsd-msg384-message-history]')) return 'message';
    if (isOverlayMedia(video)) return 'modal-viewer';
    if (video.closest('[data-dsd-view-story], .dsd-story385__story, .dsd-story385__canvas')) return 'story';
    if (video.closest('.dsd-post-card')) return 'feed';
    if (video.closest('[data-dsd-community-shell]')) return 'community';
    return 'social';
  }

  function ownerFor(video, meta){
    if (meta && meta.owner) return meta.owner;
    return video.getAttribute('data-dsd-media-owner') || 'GlobalMediaOwnershipRuntime';
  }

  var OVERLAY_SELECTOR = '[data-dsd-modal],[role="dialog"],.dsd-modal,.dsd-immersive-overlay,[data-dsd-post-drawer],[data-dsd-message-drawer],.dsd-msg384__conversation,[data-dsd-profile-modal-layer],[data-dsd-story-composer-layer],[data-dsd-global-post-composer-layer],[data-dsd-universal-search-layer],[data-dsd-report-modal-layer]';

  function isOverlayMedia(video){
    return !!(video && video.closest && video.closest(OVERLAY_SELECTOR));
  }

  function isManualPaused(video){ return !!(video && manualPauseState.get(video)); }

  function drawerVideoKind(video){
    if (!video) return '';
    if (video.closest('.dsd-post-drawer__post-media')) return 'preview';
    if (video.closest('.dsd-launch-comment-media')) return 'comments';
    return '';
  }

  function commentDrawerPriority(){
    return document.documentElement.getAttribute('data-dsd-comment-video-priority') || 'preview';
  }

  function setCommentDrawerPriority(priority){
    priority = priority === 'comments' ? 'comments' : 'preview';
    document.documentElement.setAttribute('data-dsd-comment-video-priority', priority);
    if (activeVideo && !autoplayAllowed(activeVideo)) pause(activeVideo, 'comment-drawer-priority-' + priority);
    requestAutoplay();
    return priority;
  }

  function clearCommentDrawerPriority(){
    document.documentElement.removeAttribute('data-dsd-comment-video-priority');
  }

  function autoplayAllowed(video){
    if (video && video.closest && video.closest('[data-dsd-message-view-once="true"],[data-dsd-message-view-once-revealed="true"]')) return false;
    if (!document.documentElement.classList.contains('dsd-post-drawer-open')) return true;
    var kind = drawerVideoKind(video);
    if (!kind) return false;
    return kind === commentDrawerPriority();
  }

  function mutedPreference(){
    try {
      var saved = localStorage.getItem(VIDEO_MUTED_KEY);
      return saved == null ? true : saved !== 'false';
    } catch(e){ return true; }
  }

  function applyMutePreference(video, muted){
    if (!video) return;
    muted = !!muted || !!(externalAudio && !externalAudio.paused && !externalAudio.ended);
    muteWriteSuppressedUntil.set(video, Date.now() + 300);
    video.muted = !!muted;
    video.defaultMuted = !!muted;
    if (muted) video.setAttribute('muted', '');
    else video.removeAttribute('muted');
  }

  function setMutedPreference(muted, source){
    try { localStorage.setItem(VIDEO_MUTED_KEY, muted ? 'true' : 'false'); } catch(e){}
    videos.forEach(function(meta, video){ if (video !== source) applyMutePreference(video, muted); });
    document.dispatchEvent(new CustomEvent('dsd:gmor:preference-changed', { detail: { muted: !!muted } }));
  }

  function claimExternalAudio(media){
    if (!media || media.tagName !== 'AUDIO' || media.paused || media.ended) return false;
    if (externalAudio && externalAudio !== media && !externalAudio.paused) externalAudio.pause();
    externalAudio = media;
    videos.forEach(function(meta, video){ applyMutePreference(video, true); });
    writeDomState();
    return true;
  }

  function releaseExternalAudio(media){
    if (!externalAudio || externalAudio !== media) return;
    externalAudio = null;
    videos.forEach(function(meta, video){ applyMutePreference(video, mutedPreference()); });
    writeDomState();
  }

  function yieldExternalAudio(){
    var media = externalAudio;
    if (!media) return;
    releaseExternalAudio(media);
    if (!media.paused) media.pause();
  }

  function normalize(video, meta){
    video.setAttribute('data-dsd-gmor-video', 'true');
    video.setAttribute('data-dsd-media-surface', surfaceFor(video, meta));
    video.setAttribute('data-dsd-media-owner', ownerFor(video, meta));
    if (meta && meta.mediaId) video.setAttribute('data-dsd-media-id', meta.mediaId);
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    applyMutePreference(video, mutedPreference());
    if (!video.getAttribute('preload')) video.preload = 'metadata';
  }

  function cancelPlaybackRecovery(video, reason){
    var recovery = video && playbackRecoveryByVideo.get(video);
    if (recovery && typeof recovery.cancel === 'function') recovery.cancel(reason || 'cancelled');
  }

  function playWhenReady(video, meta){
    if (!video || !video.isConnected || isManualPaused(video) || document.hidden) return Promise.resolve(false);
    var existing = playbackRecoveryByVideo.get(video);
    if (existing && existing.promise) return existing.promise;
    var startedAt = Date.now();
    var attempts = 0;
    var recoveryTimer = null;
    var startupTimer = null;
    var resolvePlayback;
    var settled = false;
    var recovery = {};
    var attemptSerial = 0;
    function eligible(){
      return !!(video && video.isConnected && !document.hidden && !isManualPaused(video) && autoplayAllowed(video) && isVisible(video));
    }
    function cleanup(){
      video.removeEventListener('loadeddata', recover);
      video.removeEventListener('canplay', recover);
      video.removeEventListener('playing', playbackStarted);
      if (recoveryTimer) window.clearTimeout(recoveryTimer);
      if (startupTimer) window.clearTimeout(startupTimer);
      recoveryTimer = null;
      startupTimer = null;
    }
    function finish(ok){
      if (settled) return;
      settled = true;
      cleanup();
      playbackRecoveryByVideo.delete(video);
      playbackDiagnostics.lastStartupMs = Math.max(0, Date.now() - startedAt);
      resolvePlayback(!!ok);
    }
    function playbackStarted(){ finish(true); }
    function recover(){
      cleanup();
      playbackDiagnostics.recoveries += 1;
      attempt(true);
    }
    function armRecovery(){
      cleanup();
      if (!eligible() || attempts >= 3) return finish(false);
      video.addEventListener('loadeddata', recover, { once:true });
      video.addEventListener('canplay', recover, { once:true });
      recoveryTimer = window.setTimeout(recover, 1200);
    }
    function attempt(allowMutedFallback){
      cleanup();
      if (!eligible() || attempts >= 3) return finish(false);
      attempts += 1;
      playbackDiagnostics.attempts += 1;
      if (video.preload === 'none') {
        video.preload = 'metadata';
        video.setAttribute('preload', 'metadata');
      }
      var serial = ++attemptSerial;
      setActive(video, meta || {});
      if (activeVideo !== video) return finish(false);
      video.addEventListener('playing', playbackStarted, { once:true });
      startupTimer = window.setTimeout(function(){
        if (settled || serial !== attemptSerial) return;
        playbackDiagnostics.recoveries += 1;
        playbackDiagnostics.lastError = 'play-startup-timeout';
        cleanup();
        programmaticPauseUntil.set(video, Date.now() + 150);
        try { video.pause(); } catch(e){}
        attempt(true);
      }, 1800);
      var attemptResult;
      try { attemptResult = video.play(); }
      catch(error) {
        playbackDiagnostics.rejections += 1;
        playbackDiagnostics.lastError = String(error && (error.name || error.message) || 'play-threw');
        return armRecovery();
      }
      if (!attemptResult || typeof attemptResult.then !== 'function') return finish(true);
      attemptResult.then(function(){ if (serial === attemptSerial) finish(true); }).catch(function(error){
        if (serial !== attemptSerial || settled) return;
        playbackDiagnostics.rejections += 1;
        playbackDiagnostics.lastError = String(error && (error.name || error.message) || 'play-rejected');
        if (allowMutedFallback && !video.muted) {
          applyMutePreference(video, true);
          attempt(false);
          return;
        }
        armRecovery();
      });
    }
    recovery.promise = new Promise(function(resolve){ resolvePlayback = resolve; });
    recovery.cancel = function(reason){
      playbackDiagnostics.lastError = String(reason || 'cancelled');
      finish(false);
    };
    playbackRecoveryByVideo.set(video, recovery);
    attempt(true);
    return recovery.promise;
  }

  function pause(video, reason){
    if (!video) return;
    cancelPlaybackRecovery(video, reason || 'paused');
    programmaticPauseUntil.set(video, Date.now() + 150);
    try { video.pause(); } catch(e){}
    applyMutePreference(video, mutedPreference());
    video.classList.remove('dsd-gmor-active');
    video.setAttribute('data-dsd-gmor-state', reason || 'paused');
    if (activeVideo === video) {
      activeVideo = null;
      activeOwner = '';
    }
    writeDomState();
  }

  function setActive(video, meta){
    if (!video) return Promise.resolve(false);
    if (!autoplayAllowed(video)) return Promise.resolve(false);
    if (meta && meta.userGesture === true) yieldExternalAudio();
    normalize(video, meta);
    var owner = ownerFor(video, meta);
    if (activeVideo && activeVideo !== video) pause(activeVideo, 'released-by-' + owner);
    activeVideo = video;
    activeOwner = owner;
    video.classList.add('dsd-gmor-active');
    video.setAttribute('data-dsd-gmor-state', 'active');
    document.dispatchEvent(new CustomEvent('dsd:gmor:owner-changed', { detail: snapshot() }));
    writeDomState();
    return Promise.resolve(true);
  }

  function viewportRatio(video, knownRect){
    if (!video || !video.isConnected) return 0;
    var rect = knownRect || video.getBoundingClientRect();
    if (!rect.width || !rect.height) return 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 1;
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var x = Math.max(0, Math.min(rect.right, vw) - Math.max(rect.left, 0));
    var y = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
    return (x * y) / Math.max(1, rect.width * rect.height);
  }

  function isVisible(video){
    if (!video || !video.isConnected) return false;
    if (isManualPaused(video)) return false;
    if (!autoplayAllowed(video)) return false;
    if (modalOwner && !isOverlayMedia(video)) return false;
    return viewportRatio(video) >= 0.35;
  }

  function visibilityScore(video){
    if (!video || !video.isConnected) return 0;
    if (isManualPaused(video)) return 0;
    if (!autoplayAllowed(video)) return 0;
    if (modalOwner && !isOverlayMedia(video)) return 0;
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 1;
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var ratio = viewportRatio(video, rect);
    if (ratio < 0.35) return 0;
    var center = rect.top + (rect.height / 2);
    var centerBias = 1 - Math.min(1, Math.abs(center - (vh / 2)) / Math.max(1, vh / 2));
    var centerX = rect.left + (rect.width / 2);
    var horizontalBias = 1 - Math.min(1, Math.abs(centerX - (vw / 2)) / Math.max(1, vw / 2));
    var activeHysteresis = video === activeVideo && !video.paused ? 0.12 : 0;
    return ratio + (centerBias * 0.08) + (horizontalBias * 0.12) + activeHysteresis;
  }

  function cleanupVideos(){
    videos.forEach(function(meta, video){
      if (!video || !video.isConnected) {
        if (observer && video) {
          try { observer.unobserve(video); } catch(e){}
        }
        videos.delete(video);
        if (prewarmVideo === video) prewarmVideo = null;
        if (activeVideo === video) {
          activeVideo = null;
          activeOwner = '';
        }
      }
    });
  }

  function mediaSequenceGroup(video){
    return video && video.closest ? video.closest('.dsd-launch-media-grid[data-dsd-media-count],.dsd-launch-comment-media-grid[data-dsd-media-count],.dsd-shared-post__media-grid[data-dsd-media-count],.dsd-msg384__message-media[data-dsd-media-count],.dsd-story385__tray') : null;
  }

  function sequenceCandidateBonus(video){
    if (!activeVideo || !video || video === activeVideo) return 0;
    var activeGroup = mediaSequenceGroup(activeVideo);
    var candidateGroup = mediaSequenceGroup(video);
    if (!activeGroup || candidateGroup !== activeGroup) return 0;
    var groupVideos = qsa('video', activeGroup);
    var activeIndex = groupVideos.indexOf(activeVideo);
    var candidateIndex = groupVideos.indexOf(video);
    if (activeIndex < 0 || candidateIndex < 0) return 0;
    var delta = candidateIndex - activeIndex;
    return delta > 0 ? 4 + (1 / delta) : 0.2;
  }

  function nearViewportScore(video){
    if (!video || !video.isConnected || video === activeVideo) return 0;
    if (!autoplayAllowed(video) || isManualPaused(video) || isOverlayMedia(video)) return 0;
    var surface = surfaceFor(video, videos.get(video) || {});
    if (surface !== 'feed' && surface !== 'story' && surface !== 'social' && surface !== 'community') return 0;
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 1;
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var verticalMargin = Math.min(420, Math.max(220, vh * 0.45));
    var horizontalMargin = Math.min(220, Math.max(96, vw * 0.35));
    if (rect.bottom < -verticalMargin || rect.top > vh + verticalMargin) return 0;
    if (rect.right < -horizontalMargin || rect.left > vw + horizontalMargin) return 0;
    var centerY = rect.top + (rect.height / 2);
    var centerX = rect.left + (rect.width / 2);
    var verticalDistance = Math.abs(centerY - (vh / 2));
    var horizontalDistance = Math.abs(centerX - (vw / 2));
    var geometryScore = 1 / (1 + verticalDistance + (horizontalDistance * 0.65));
    return sequenceCandidateBonus(video) + geometryScore;
  }

  function prewarmBestNearViewportVideo(){
    cleanupVideos();
    var previousCandidate = prewarmVideo;
    var candidate = null;
    var candidateScore = 0;
    videos.forEach(function(meta, video){
      var score = nearViewportScore(video);
      if (score > candidateScore) {
        candidate = video;
        candidateScore = score;
      }
    });
    if (prewarmVideo && prewarmVideo !== candidate && prewarmVideo !== activeVideo && prewarmVideo.paused) {
      prewarmVideo.preload = 'none';
      prewarmVideo.setAttribute('preload', 'none');
      prewarmVideo.removeAttribute('data-dsd-gmor-prewarmed');
    }
    prewarmVideo = candidate;
    videos.forEach(function(meta, video){
      if (video === activeVideo || video === candidate || isOverlayMedia(video) || !video.paused || viewportRatio(video) >= 0.05) return;
      video.preload = 'none';
      video.setAttribute('preload', 'none');
      video.removeAttribute('data-dsd-gmor-prewarmed');
    });
    if (!candidate || candidate === activeVideo || !candidate.paused) return;
    if (candidate !== previousCandidate) playbackDiagnostics.prewarmChanges += 1;
    candidate.preload = 'metadata';
    candidate.setAttribute('preload', 'metadata');
    candidate.setAttribute('data-dsd-gmor-prewarmed', 'true');
    if (candidate.networkState === 0 && typeof candidate.load === 'function') {
      try { candidate.load(); } catch(e){}
    }
  }

  function scheduleNearViewportPrewarm(){
    if (pendingPrewarmTimer) window.clearTimeout(pendingPrewarmTimer);
    pendingPrewarmTimer = window.setTimeout(function(){
      pendingPrewarmTimer = null;
      prewarmBestNearViewportVideo();
    }, 48);
  }

  function bestVisibleVideo(){
    var best = null;
    var bestScore = 0;
    cleanupVideos();
    videos.forEach(function(meta, video){
      var score = visibilityScore(video);
      if (score > bestScore) {
        best = video;
        bestScore = score;
      }
    });
    return best;
  }

  function requestAutoplay(video, meta){
    if (video && meta) videos.set(video, Object.assign({}, videos.get(video) || {}, meta || {}));
    if (pendingAutoplayFrame) return;
    pendingAutoplayFrame = window.requestAnimationFrame(function(){
      pendingAutoplayFrame = null;
      var candidate = bestVisibleVideo();
      if (!candidate) return;
      var now = Date.now();
      var last = lastAutoplayAttempt.get(candidate) || 0;
      if (candidate === activeVideo && !candidate.paused && now - last < AUTOPLAY_COOLDOWN_MS) return;
      lastAutoplayAttempt.set(candidate, now);
      maybeAutoplay(candidate, videos.get(candidate) || {});
    });
  }

  function maybeAutoplay(video, meta){
    if (!video || !isVisible(video) || isManualPaused(video)) return Promise.resolve(false);
    applyMutePreference(video, mutedPreference());
    return playWhenReady(video, Object.assign({}, meta || {}, { userGesture: false }));
  }

  function initObserver(){
    if (observer || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          requestAutoplay(video, videos.get(video) || {});
        } else {
          var wasActive = activeVideo === video;
          if (wasActive) pause(video, 'viewport-exit');
          if (!isOverlayMedia(video) && video !== prewarmVideo && !wasActive) {
            video.preload = 'none';
            video.setAttribute('preload', 'none');
          }
          scheduleNearViewportPrewarm();
        }
      });
    }, { threshold: [0, 0.35, 0.65, 1] });
  }

  function register(video, meta){
    if (!video || video.tagName !== 'VIDEO') return null;
    normalize(video, meta || {});
    videos.set(video, Object.assign({}, videos.get(video) || {}, meta || {}));
    if (!registered.has(video)) {
      registered.add(video);
      initObserver();
      if (observer) observer.observe(video);
      ['pointerdown', 'touchstart', 'mousedown'].forEach(function(type){
        video.addEventListener(type, function(){ userGestureState.set(video, { at: Date.now(), wasPaused: !!video.paused }); }, { passive: true });
      });
      video.addEventListener('keydown', function(event){
        if (event.key === 'Enter' || event.key === ' ') userGestureState.set(video, { at: Date.now(), wasPaused: !!video.paused });
      });
      video.addEventListener('play', function(){
        var gesture = userGestureState.get(video) || {};
        var explicitPlay = Date.now() - Number(gesture.at || 0) < 1600 && gesture.wasPaused === true;
        if (explicitPlay) yieldExternalAudio();
        if (explicitPlay) manualPauseState.set(video, false);
        var drawerKind = drawerVideoKind(video);
        if (explicitPlay && drawerKind) setCommentDrawerPriority(drawerKind);
        if (activeVideo && activeVideo !== video) pause(activeVideo, 'native-play');
        activeVideo = video;
        activeOwner = ownerFor(video, videos.get(video) || {});
        video.classList.add('dsd-gmor-active');
        writeDomState();
        scheduleNearViewportPrewarm();
      }, true);
      video.addEventListener('pause', function(){
        var gesture = userGestureState.get(video) || {};
        var userPaused = Date.now() > Number(programmaticPauseUntil.get(video) || 0) &&
            Date.now() - Number(gesture.at || 0) < 1600 &&
            gesture.wasPaused === false;
        if (userPaused) {
          manualPauseState.set(video, true);
          cancelPlaybackRecovery(video, 'manual-pause');
        }
        video.classList.remove('dsd-gmor-active');
        if (activeVideo === video) {
          activeVideo = null;
          activeOwner = '';
        }
        writeDomState();
        scheduleNearViewportPrewarm();
      }, true);
      video.addEventListener('volumechange', function(){
        if (Date.now() <= Number(muteWriteSuppressedUntil.get(video) || 0)) return;
        var requestedMuted = !!video.muted;
        if (externalAudio && !requestedMuted) {
          setMutedPreference(false, video);
          yieldExternalAudio();
          return;
        }
        setMutedPreference(!!video.muted, video);
      }, true);
      video.addEventListener('ended', function(){
        if (activeVideo === video) pause(video, 'ended');
      }, true);
      document.dispatchEvent(new CustomEvent('dsd:gmor:registered', { detail: { version: VERSION, surface: surfaceFor(video, meta || {}), owner: ownerFor(video, meta || {}) } }));
    }
    writeDomState();
    if (isVisible(video) && !modalOwner) requestAutoplay(video, meta || {});
    scheduleNearViewportPrewarm();
    return video;
  }

  function scan(root){
    cleanupVideos();
    var scope = root || document;
    var candidates = qsa('video, .dsd-media-frame--video video, [data-dsd-media-kind="video"] video, video.track-video-views[data-video-id]', scope);
    if (scope && scope.tagName === 'VIDEO' && candidates.indexOf(scope) < 0) candidates.unshift(scope);
    playbackDiagnostics.scans += 1;
    playbackDiagnostics.scannedVideos += candidates.length;
    candidates.forEach(function(video){
      register(video, { owner: video.getAttribute('data-dsd-media-owner') || 'GMORScan', surface: surfaceFor(video, {}) });
    });
    return snapshot();
  }

  function requestScan(root){
    root = root || document;
    if (pendingScanRoots.indexOf(root) < 0) pendingScanRoots.push(root);
    if (pendingScanTimer) window.clearTimeout(pendingScanTimer);
    pendingScanTimer = window.setTimeout(function(){
      pendingScanTimer = null;
      var roots = pendingScanRoots.splice(0).filter(function(scanRoot, index, allRoots){
        return !allRoots.some(function(parentRoot, parentIndex){
          return parentIndex !== index && parentRoot && parentRoot.contains && parentRoot.contains(scanRoot);
        });
      });
      cleanupVideos();
      roots.forEach(function(scanRoot){
        var candidates = qsa('video, .dsd-media-frame--video video, [data-dsd-media-kind="video"] video, video.track-video-views[data-video-id]', scanRoot);
        if (scanRoot && scanRoot.tagName === 'VIDEO' && candidates.indexOf(scanRoot) < 0) candidates.unshift(scanRoot);
        playbackDiagnostics.scans += 1;
        playbackDiagnostics.scannedVideos += candidates.length;
        candidates.forEach(function(video){
          register(video, { owner: video.getAttribute('data-dsd-media-owner') || 'GMORScan', surface: surfaceFor(video, {}) });
        });
      });
      scheduleNearViewportPrewarm();
      requestAutoplay();
    }, SCAN_DEBOUNCE_MS);
  }

  function requestViewportAutoplay(){
    if (pendingViewportTimer) window.clearTimeout(pendingViewportTimer);
    pendingViewportTimer = window.setTimeout(function(){
      pendingViewportTimer = null;
      scheduleNearViewportPrewarm();
      requestAutoplay();
    }, VIEWPORT_DEBOUNCE_MS);
  }

  function unlockMediaSession(){
    if (mediaUnlocked) return;
    mediaUnlocked = true;
    ['pointerdown','touchstart','click','keydown'].forEach(function(type){
      document.removeEventListener(type, unlockMediaSession, true);
    });
    document.documentElement.setAttribute('data-dsd-media-unlocked', 'true');
    writeDomState();
  }

  function bindUnlock(){
    ['pointerdown','touchstart','click','keydown'].forEach(function(type){
      document.addEventListener(type, unlockMediaSession, { capture:true, passive:true });
    });
  }

  function modalDepth(){
    return Object.keys(modalClaims).reduce(function(total, owner){
      return total + Number(modalClaims[owner] || 0);
    }, 0);
  }

  function refreshModalOwner(){
    modalClaimOrder = modalClaimOrder.filter(function(owner){ return Number(modalClaims[owner] || 0) > 0; });
    modalOwner = modalClaimOrder.length ? modalClaimOrder[modalClaimOrder.length - 1] : '';
    if (modalOwner) document.documentElement.setAttribute('data-dsd-gmor-modal-owner', modalOwner);
    else document.documentElement.removeAttribute('data-dsd-gmor-modal-owner');
  }

  function claimModal(owner){
    owner = owner || 'modal';
    var wasOpen = modalDepth() > 0;
    modalClaims[owner] = 1;
    modalClaimOrder = modalClaimOrder.filter(function(entry){ return entry !== owner; });
    modalClaimOrder.push(owner);
    refreshModalOwner();
    if (!wasOpen && activeVideo && !isOverlayMedia(activeVideo)) {
      modalResumeCandidate = activeVideo;
      modalResumeWasPlaying = !activeVideo.paused && !activeVideo.ended;
      pause(activeVideo, 'modal-opened');
    }
    writeDomState();
  }

  function releaseModal(owner){
    owner = owner || modalOwner;
    if (owner && modalClaims[owner]) {
      modalClaims[owner] -= 1;
      if (modalClaims[owner] <= 0) delete modalClaims[owner];
    }
    refreshModalOwner();
    writeDomState();
    if (modalDepth() === 0) {
      var candidate = modalResumeCandidate;
      var shouldResume = !!(modalResumeWasPlaying && candidate && candidate.isConnected && !isManualPaused(candidate));
      modalResumeCandidate = null;
      modalResumeWasPlaying = false;
      window.setTimeout(function(){
        if (shouldResume && !modalOwner && isVisible(candidate)) {
          maybeAutoplay(candidate, videos.get(candidate) || {});
        }
      }, 80);
    }
  }

  function toggle(video, meta){
    if (!video) return Promise.resolve(false);
    register(video, meta || {});
    if (video.paused || video.ended) {
      manualPauseState.set(video, false);
      applyMutePreference(video, mutedPreference());
      return playWhenReady(video, meta || {});
    }
    manualPauseState.set(video, true);
    pause(video, 'user-toggle');
    return Promise.resolve(true);
  }

  function pauseActive(reason){
    if (activeVideo) pause(activeVideo, reason || 'pause-active');
  }

  function snapshot(){
    return {
      version: VERSION,
      recoveredFrom: SOURCE,
      registered: videos.size,
      activeOwner: activeOwner,
      activeSurface: activeVideo ? surfaceFor(activeVideo, videos.get(activeVideo) || {}) : '',
      activePaused: activeVideo ? activeVideo.paused : true,
      activeVisible: activeVideo ? isVisible(activeVideo) : false,
      pendingAutoplay: !!pendingAutoplayFrame,
      mediaUnlocked: mediaUnlocked,
      modalOwner: modalOwner,
      modalDepth: modalDepth(),
      prewarmSurface: prewarmVideo ? surfaceFor(prewarmVideo, videos.get(prewarmVideo) || {}) : '',
      playback: Object.assign({}, playbackDiagnostics)
    };
  }

  function writeDomState(){
    if (!document.documentElement) return;
    var root = document.documentElement;
    root.setAttribute('data-dsd-gmor', 'active');
    root.setAttribute('data-dsd-gmor-version', VERSION);
    root.setAttribute('data-dsd-gmor-source', SOURCE);
    root.setAttribute('data-dsd-gmor-registered', String(videos.size));
    root.setAttribute('data-dsd-gmor-active-owner', activeOwner || '');
    root.setAttribute('data-dsd-gmor-active-surface', activeVideo ? surfaceFor(activeVideo, videos.get(activeVideo) || {}) : '');
    root.setAttribute('data-dsd-gmor-active-visible', activeVideo && isVisible(activeVideo) ? 'true' : 'false');
    root.setAttribute('data-dsd-gmor-pending-autoplay', pendingAutoplayFrame ? 'true' : 'false');
    root.setAttribute('data-dsd-gmor-unlocked', mediaUnlocked ? 'true' : 'false');
    root.setAttribute('data-dsd-gmor-modal-owner', modalOwner || '');
    root.setAttribute('data-dsd-gmor-external-audio', externalAudio && !externalAudio.paused && !externalAudio.ended ? 'playing' : 'none');
  }

  function boot(){
    if (booted) return;
    booted = true;
    claimRuntime();
    bindUnlock();
    scan(document);
    if ('MutationObserver' in window) {
      mutationObserver = new MutationObserver(function(records){
        records.forEach(function(record){
          Array.prototype.forEach.call(record.addedNodes || [], function(node){
            if (node && node.nodeType === 1 && (node.tagName === 'VIDEO' || (node.querySelector && node.querySelector('video,[data-dsd-media-kind="video"]')))) requestScan(node);
          });
        });
      });
      mutationObserver.observe(document.documentElement, { childList:true, subtree:true });
    }
    document.addEventListener('visibilitychange', function(){ if (document.hidden) pauseActive('document-hidden'); else requestViewportAutoplay(); });
    window.addEventListener('scroll', requestViewportAutoplay, { passive:true });
    window.addEventListener('resize', requestViewportAutoplay, { passive:true });
    document.addEventListener('shopify:section:load', function(event){ scan(event.target || document); });
    document.addEventListener('dsd:modal-opened', function(){ claimModal('dsd-modal'); });
    document.addEventListener('dsd:modal-closed', function(){ releaseModal('dsd-modal'); });
  }

  window.DSDGMOR = {
    version: VERSION,
    register: register,
    registerAll: scan,
    scan: scan,
    primeCounts: function(){ return snapshot(); },
    loadNextProfileChunk: function(){ return false; },
    toggle: toggle,
    pauseVideo: pause,
    isManualPaused: isManualPaused,
    mutedPreference: mutedPreference,
    setActive: setActive,
    playWhenReady: playWhenReady,
    pauseActive: pauseActive,
    claimExternalAudio: claimExternalAudio,
    releaseExternalAudio: releaseExternalAudio,
    claimModal: claimModal,
    releaseModal: releaseModal,
    setCommentDrawerPriority: setCommentDrawerPriority,
    clearCommentDrawerPriority: clearCommentDrawerPriority,
    unlock: unlockMediaSession,
    snapshot: snapshot
  };
  window.DSDMedia = window.DSDGMOR;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  boot();
})();
